import React from 'react';
import { LAYOUT } from '../../styles/constants';
import useMediaQuery from '../../hooks/useMediaQuery';
import { Calendar, Clock, MapPin, DollarSign } from 'lucide-react';

interface EventCardProps {
  imageUrl: string;
  index: number;
  details: {
    name: string;
    date: string;
    time: string;
    location: string;
    fee: string;
  };
}

const EventCard = ({ imageUrl, index, details }: EventCardProps) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div 
      style={{ 
        width: isDesktop ? LAYOUT.NEWS_EVENTS.CARD.WIDTH : '100%',
        maxWidth: LAYOUT.NEWS_EVENTS.CARD.WIDTH
      }}
      className="w-full bg-white shadow-lg overflow-hidden rounded-t-lg"
    >
      <img
        src={imageUrl}
        alt={`Event ${index}`}
        style={{ 
          height: LAYOUT.NEWS_EVENTS.CARD.IMAGE.HEIGHT
        }}
        className="w-full object-cover rounded-t-lg"
      />
      <div 
        className="p-6 flex flex-col justify-between"
        style={{ 
          height: LAYOUT.NEWS_EVENTS.CARD.DESCRIPTION.HEIGHT
        }}
      >
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <span className="font-semibold min-w-[80px]">Name:</span>
            <span className="text-gray-600">{details.name}</span>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="font-semibold min-w-[80px]">Date:</span>
            <span className="text-gray-600 flex items-center gap-2">
              <Calendar size={16} />
              {details.date}
            </span>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="font-semibold min-w-[80px]">Time:</span>
            <span className="text-gray-600 flex items-center gap-2">
              <Clock size={16} />
              {details.time}
            </span>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="font-semibold min-w-[80px]">Location:</span>
            <span className="text-gray-600 flex items-center gap-2">
              <MapPin size={16} />
              {details.location}
            </span>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="font-semibold min-w-[80px]">Fee:</span>
            <span className="text-gray-600 flex items-center gap-2">
              <DollarSign size={16} />
              {details.fee}
            </span>
          </div>
        </div>

        <div className="mt-6">
          <button 
            className="w-full bg-[#0A1F87] text-white py-3 rounded hover:bg-[#0A1F87]/90 transition-colors"
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventCard;